import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const LAYOUTS = [
  { key: "1x2", label: "1 × 2", desc: "2 per page (current default)" },
  { key: "1x1", label: "1 × 1", desc: "1 per page, top-half content, bottom-half blank" },
];

// Preview: outer rectangle divided per layout; for 1x1 only top-half filled.
function LayoutPreview({ layoutKey }) {
  const isTopHalfOnly = layoutKey === "1x1";
  const rows = isTopHalfOnly ? 2 : 2;
  const totalFilled = isTopHalfOnly ? 1 : 2;
  const cells = [];
  for (let i = 0; i < totalFilled; i++) {
    cells.push(
      <div key={`f-${i}`} className="rounded-[2px] border border-blue-500 bg-blue-100/60" />
    );
  }
  // For 1x1, add a blank cell placeholder to preserve top-half layout
  if (isTopHalfOnly) {
    cells.push(<div key="blank" />);
  }
  return (
    <div
      className="grid h-14 w-10 gap-0.5 rounded-sm border border-zinc-300 bg-white p-1"
      style={{
        gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
        gridTemplateRows: `repeat(${rows}, minmax(0, 1fr))`,
      }}
    >
      {cells}
    </div>
  );
}

export function BestSellingLayoutPickerDialog({ open, onOpenChange, onPick }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-sm" data-testid="best-selling-layout-picker-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Choose print layout</DialogTitle>
          <DialogDescription className="text-xs text-zinc-500">
            1×2 prints two items per page. 1×1 prints one item on the top half with the bottom half blank (useful for samples).
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 gap-2">
          {LAYOUTS.map((layout) => (
            <button
              type="button"
              key={layout.key}
              onClick={() => {
                onPick(layout.key);
                onOpenChange(false);
              }}
              className="flex items-center gap-4 rounded-sm border border-zinc-300 bg-white px-3 py-2 text-left transition-colors hover:border-blue-600 hover:bg-blue-50"
              data-testid={`best-selling-layout-option-${layout.key}`}
            >
              <LayoutPreview layoutKey={layout.key} />
              <div className="flex-1">
                <div className="font-heading text-base font-semibold text-zinc-900">{layout.label}</div>
                <div className="text-xs text-zinc-500">{layout.desc}</div>
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
